module.exports = __webpack_public_path__ + "img/return-home.f999292b.png";